<template>
  <UiChip
    class="filter-popup-chip"
    :label="label"
    :selected="selected"
    :size="chipSize"
    right-icon="arrow"
    :show-items-count="showItemsCount"
    :label-items-count="labelItemsCount"
    @click="onOpen"
  />
</template>

<script setup lang="ts">
  import { UiChip, Size } from '@experience/core-chips-ui';
  import { MAX_TYPES_IN_BUTTON } from '../lib/const.ts';

  interface Props {
    label: string;
    selected?: boolean;
    isScroll?: boolean;
    itemsCount?: number;
  }

  interface Emits {
    (e: 'open'): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const chipSize = computed(() => (props.isScroll ? Size.S : Size.M));

  const showItemsCount = computed(() => (props.itemsCount ?? 0) > MAX_TYPES_IN_BUTTON);

  const labelItemsCount = computed(() => (showItemsCount.value ? props.itemsCount : undefined));

  const onOpen = () => {
    emit('open');
  };
</script>

<style scoped lang="scss">
  // В shadow DOM MF стили ellipsis из core-chips-ui иногда не применяются —
  // дублируем ограничение ширины (как в small-output после EXP-18966).
  // Два класса (.filter-popup-chip.ui-chip), чтобы перебить
  // `.listing-page .ui-chip { max-width: inherit }` со страницы листинга.
  .filter-popup-chip.ui-chip {
    max-width: 280px;

    :deep(.ui-chip__label-container) {
      max-width: calc(280px - var(--chip-padding-left) - var(--chip-padding-right));
    }

    :deep(.ui-chip__label) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  // Класс with-items-count на корне UiChip (тот же элемент, что filter-popup-chip).
  // Счётчик уже рисует «... (N)» — CSS-ellipsis отключаем, иначе получается «... ... (N)».
  .filter-popup-chip.ui-chip--with-items-count {
    :deep(.ui-chip__label) {
      text-overflow: clip;
    }
  }
</style>
